import React from 'react'
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from './Pages/HomePage';
import ProductPage from './Pages/ProductDetails';
import ProductList from './Pages/ProductList';
import SignupPage from "./component/Auth/SignupPage"
import LoginPage from "./component/Auth/LoginPage"
import NotFound from "./component/NotFound"
import AboutUs from "./component/AboutUs"
import ContactUs from "./component/ContactUs"
//Private Route Start from here
import PrivateRoute from "./route/privateRoute"
import Cart from './Pages/Cart';
import CheckOut from "./Pages/CheckOut"
import MyOrder from "./Pages/MyOrder"
//Admin Page Starts from Here
import AdminRoute from "./route/adminRoute"
import AdminLogin from "./Admin/Auth/Login"
import AdminHomePage from "./Admin/home/Home"
import AdminOrderDetails from "./Admin/orders/OrderDetails"
import AdminOrderList from "./Admin/orders/OrdersListPage"
import AdminCustomerList from "./Admin/customer/Customers"
import AdminCustomerDetailsPage from "./Admin/customer/CustomerDetailsPage"
import AdminSettingsPges from "./Admin/settings/Settings"
import AdminProductList from "./Admin/products/ProductList"
import AdminProductDetails from "./Admin/products/ProductDetails"
import AdminAddProduct from "./Admin/addProduct/AddProduct"

const App = () => {

  // Usage Example:

  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/product/:id" element={<ProductPage />} />
          <Route path="/shop" element={<ProductList />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/*" element={<NotFound />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/contact" element={<ContactUs />} />
          {/* Private Routes Starts From Here */}
          <Route element={<PrivateRoute />}>
            <Route path="/cart" element={<Cart />} />
            <Route path="/checkout" element={<CheckOut />} />
            <Route path="/my-order" element={<MyOrder />} />
          </Route>

          {/* Admin Routes Starts From Here */}
          <Route element={<AdminRoute />}>
            <Route path="/admin" element={<AdminHomePage />} />
            <Route path="/admin/orders" element={<AdminOrderList />} />
            <Route path="/admin/orders/:id" element={<AdminOrderDetails />} />
            <Route path="/admin/customers" element={<AdminCustomerList />} />
            <Route path="/customers/:id" element={<AdminCustomerDetailsPage />} />
            <Route path="/admin/settings" element={<AdminSettingsPges />} />
            <Route path="/admin/products" element={<AdminProductList />} />
            <Route path="/admin/add-products" element={<AdminAddProduct />} />
            <Route path="/admin/products/:id" element={<AdminProductDetails />} />
          </Route>
        </Routes>
      </Router>

    </>
  )
}

export default App